import { gql } from '@apollo/client';

export const getCategoryQuery = gql`
  query getCategory($input: GetCategoryInput!) {
    getCategory(input: $input) {
      id
      code
      lastDisabledDate
      lastEnabledDate
      logo {
        url
      }
      name_en
      name_ky
      name_ru
      name_tr
      popularityScore
      rboCode
      registrationDate
      slug
      status
      statusMessage
      tags
    }
  }
`;
